export const step1Config = {
  underBtn: {
    title: 'Continue',
    show: false,
  },
  formWidth: '50%',
  formItems: [
    {
      field: 'visaCardName',
      type: 'password',
      label: 'visaCardName',
      placeholder: 'visaCardName',
      maxlength: '35',
      minlength: '2', // Character number must be more than one.
      errorMsg: '',
      errorShow: false,
      icon: 'off',
    },
    {
      field: 'visaCardNum',
      type: 'password',
      maxlength: 19,
      label: 'visaCardNum',
      placeholder: 'visaCardNum',
      errorMsg: '',
      errorShow: false,
      icon: 'off',
      needEyeIcon: true,
    },
    {
      type: 'card',
      children: [
        {
          field: 'cardExpiryDate',
          label: 'cardExpiryDate',
          inputType: 'password',
          placeholder: 'cardExpiryDate',
          subLabel: '',
          errorMsg: '',
          errorShow: false,
          maxlength: 5,
          on: false,
          iconShow2: true,
        },
        {
          field: 'cardNum',
          label: 'cardNum',
          subLabel: '',
          inputType: 'password',
          placeholder: 'cardNum',
          errorMsg: '',
          errorShow: false,
          iconShow: true,
          iconShow2: true,
          maxlength: 4,
          type: 'password',
          on: false,
        },
      ],
    },
  ],
};
